import { lazy } from 'react';

export const PlayerUpdateCancelWithdrawalBlockForm = lazy(
  () => import('./PlayerUpdateCancelWithdrawalBlockForm'),
);
